/**
 * * (!기간제) 일반 판매 재화 테이블
 */

import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { IDetail, ICoupon } from 'utils/types/saleTypes';
import { IDropListProps } from 'utils/types/common';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import CheckboxOneType from 'components/input/CheckboxOneType';
import CircleButton from 'components/button/CircleButton';
import InputTitle from 'components/etc/InputTitle';
import { useTranslation } from 'react-i18next';
import { IItem } from '../../../utils/types/storyTypes';
import DefaultButton from '../../../components/button/DefaultButton';
import { message } from 'antd';
import { v4 as uuidv4 } from 'uuid';

interface IProps {
  items: IItem[];
  product: ICoupon;
  setProduct: Dispatch<SetStateAction<ICoupon>>;
}
const SalesCurrencyTable: React.FC<IProps> = ({
  items,
  product,
  setProduct,
}) => {
  const { t } = useTranslation();

  const handleSelectChange = (e, data, selectedItem: IDetail) => {
    const { value, name, id } = data;
    for (const detail of product.details) {
      if (
        detail.item_id === value &&
        detail.is_main &&
        detail.is_main === selectedItem.is_main
      ) {
        message.error('메인 상품은 중복될 수 없습니다.');
        return;
      }
    }

    const newProductDetails: IDetail[] = product.details.map((v) =>
      Number(v.id) === Number(id) ? { ...v, item_id: value } : v,
    );
    setProduct({ ...product, details: newProductDetails });
  };

  const handleInputChange = (e, selectedItem?: IDetail) => {
    const { value, name, id, checked } = e.target;
    let newProductDetails: IDetail[] = [];

    if (name === 'is_main' || name === 'first_purchase') {
      if (name === 'is_main' && checked) {
        for (const detail of product.details) {
          if (detail.item_id === selectedItem!.item_id && detail.is_main) {
            message.error('메인 상품은 중복될 수 없습니다.');
            return;
          }
        }
      }

      newProductDetails = product.details.map((v) =>
        v.id === Number(id) ? { ...v, [name]: checked } : v,
      );
    } else {
      newProductDetails = product.details.map((v) =>
        v.id === Number(id) ? { ...v, [name]: value } : v,
      );
    }

    setProduct({ ...product, details: newProductDetails });
  };

  const handlePlusClick = () => {
    const newProductDetails = [
      ...product.details,
      {
        id: Date.now(),
        item_id: 0,
        quantity: 0,
        is_main: false,
        first_purchase: false,
      },
    ];

    setProduct({ ...product, details: newProductDetails });
  };

  const handleMinusClick = (e) => {
    const selectedItem = product.details?.filter(
      (v) => v.id !== Number(e.target.value),
    );

    setProduct({ ...product, details: selectedItem });
  };

  const itemDropList = items?.map((v) => ({
    key: v.id,
    text: `(${v.id}) ${v.origin_name}`,
    value: v.id,
  }));

  const canAdd = itemDropList.length > product.details.length;

  return (
    <Container>
      <div className='flex_wrap title_flex_wrap'>
        <InputTitle
          style={{ width: '15rem', textAlign: 'center', marginLeft: '0rem' }}
        >
          {t('saleCurrencyTable.input.rewardType')}
        </InputTitle>
        <InputTitle
          style={{ width: '6rem', textAlign: 'center', marginLeft: '0.5rem' }}
        >
          {t('saleCurrencyTable.input.numsReward')}
        </InputTitle>
        <InputTitle
          style={{ width: '5rem', textAlign: 'center', marginLeft: '0.5rem' }}
        >
          {t('saleCurrencyTable.input.mainCommodity')}
        </InputTitle>
        <InputTitle style={{ width: '7rem', marginLeft: '0.5rem' }}>
          {t('saleCurrencyTable.input.firstPurchaseBonus')}
        </InputTitle>
        {canAdd && (
          <DefaultButton onClick={handlePlusClick}>추가</DefaultButton>
        )}
      </div>
      {product.details.map((v, i) => (
        <div className='flex_wrap content_wrap'>
          <div style={{ marginRight: '0.5rem' }}>
            <p>{i + 1}. </p>
          </div>
          <DefaultSelect
            name='item_id'
            id={`${v.id}`}
            value={v.item_id}
            optionList={itemDropList}
            onChange={(e, data) => handleSelectChange(e, data, v)}
            showSearch
            style={{ width: '15rem', marginRight: '1rem' }}
          />
          <div className='input_wrap'>
            <DefaultInput
              name='quantity'
              id={`${v.id}`}
              value={v.quantity}
              onChange={handleInputChange}
              type='number'
            />
          </div>
          <CheckboxOneType
            name='is_main'
            id={`${v.id}`}
            checked={v.is_main}
            onChange={(e) => handleInputChange(e, v)}
            style={{ width: '5rem', marginLeft: '2rem' }}
          />
          <CheckboxOneType
            name='first_purchase'
            id={`${v.id}`}
            checked={v.first_purchase}
            onChange={handleInputChange}
            style={{ width: '5rem' }}
          />
          <CircleButton
            name='subtract'
            value={`${v.id}`}
            onClick={handleMinusClick}
          >
            -
          </CircleButton>
        </div>
      ))}
    </Container>
  );
};

export default SalesCurrencyTable;

const Container = styled.div`
  width: 100%;
  margin-top: 0.8rem;
  .flex_wrap {
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .title_flex_wrap {
    margin-bottom: 0.3rem;
    > p {
      font-weight: 500;
      font-size: ${theme.fontSizes.md};
    }
  }

  .input_wrap {
    width: 6rem;
  }
`;
